import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import favicon from '../../images/favicon.ico';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import Paragraphs from '../../components/Paragraphs/Paragraphs';
import gemeenteImage from '../../images/gemeenteImage.png';

interface DataContext {
  pageContext: {
    pageData: Queries.node__page;
    metaData: any;
    additionalData: any;
  };
}

export default function PageDetails({
  pageContext,
}: DataContext): React.JSX.Element {
  return (
    <>
      <Helmet>
        <title>{pageContext.pageData.title} | Gemeente-Stadsmonitor</title>
        <link rel="icon" type="image/png" href={favicon} sizes="16x16" />
        <meta
          name="title"
          property="og:title"
          content="Gemeente-Stadsmonitor"
        />
        <meta name="image" property="og:image" content={gemeenteImage} />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="418" />
        <meta property="og:image:height" content="315" />
      </Helmet>

      <Breadcrumbs
        links={pageContext.pageData.path?.breadcrumbs ?? []}
        currentPageTitle={pageContext.pageData.title}
      />

      <Paragraphs
        items={pageContext.pageData.relationships?.field_paragraphs ?? []}
        addtitonalData={pageContext.additionalData}
        metaData={pageContext.metaData}
      />
    </>
  );
}
